<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Cambiar contraseña</div>
  </section>

  <!-- Sección del cuerpo. -->
  <section>
    <!-- Formulario. -->
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="update()">
      <mat-form-field>
        <mat-label>ID</mat-label>
        <input
          type="number"
          name="employeeId"
          formControlName="employeeId"
          matInput
          readonly
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Contraseña nueva</mat-label>
        <input
          matInput
          [type]="newPasswordHide ? 'password' : 'text'"
          name="newPassword"
          formControlName="newPassword"
        />
        @if (formNewPassword?.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="newPasswordHide = !newPasswordHide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="newPasswordHide"
        >
          <mat-icon>{{
            newPasswordHide ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        }
        <mat-hint class="text-gray-500"
          >Minúsculas, mayúsculas, números, caracteres especiales y mínimo ocho
          caracteres.</mat-hint
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>Repetir contraseña nueva</mat-label>
        <input
          matInput
          [type]="confirmNewPasswordHide ? 'password' : 'text'"
          name="confirmNewPassword"
          formControlName="confirmNewPassword"
        />
        @if (formConfirmNewPassword?.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="confirmNewPasswordHide = !confirmNewPasswordHide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="confirmNewPasswordHide"
        >
          <mat-icon>{{
            confirmNewPasswordHide ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        }
      </mat-form-field>

      <!-- Errores. -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center mt-10">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <!-- Botón de acción. -->
      <button
        type="submit"
        mat-flat-button
        class="mt-10"
        [disabled]="form.invalid || loading"
      >
        @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Cambiar</span>
        }
      </button>
    </form>
  </section>
</div>
